import { TRootState } from 'Redux/Reducers';

export const getOrganizerCount = (state: TRootState) => state.organizer.maxCount;
